import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, Renderer2, } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW7201Model } from './kymw7201.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { CheckboxLabelComponent } from '../../../commons/kymw02/checkbox-label/checkbox-label.component';
import { RadioLabelComponent } from '../../../commons/kymw02/radio-label/radio-label.component';
import { CodeComboBoxComponent } from 'src/app/commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { ActivatedRoute, Router } from '@angular/router';
import { GetOperationGoodsService } from './api-services/get-operation-goods.service';
import { UpdateOperationGoodsService } from './api-services/update-operation-goods.service';
import { RegistOperationGoodsService } from './api-services/regist-operation-goods.service';
import { GetCodeListService } from '../../../commons/kymw02/api-services/get-code-list.service';
import { CountFixtationService } from './api-services/count-fixtation.service';

/**
 * 運営商品登録画面を管理するクラス
 *
 * @export KYMW7201Component
 * @class KYMW7201Component
 */
@Component({
  selector: 'app-kymw7201',
  templateUrl: 'kymw7201.component.html',
  styleUrls: ['kymw7201.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW7201Component extends PlessViewHelperSub implements OnInit {

  public kymw7201Model: KYMW7201Model = new KYMW7201Model();

  @ViewChild('rbtn_Weekly', { static: true }) rbtn_Weekly: RadioLabelComponent;
  @ViewChild('rbtn_Daily', { static: true }) rbtn_Daily: RadioLabelComponent;
  @ViewChild('chk_AllSeikyou', { static: true }) chk_AllSeikyou: CheckboxLabelComponent;
  @ViewChild('chk_Ibaraki', { static: true }) chk_Ibaraki: CheckboxLabelComponent;
  @ViewChild('chk_Tochigi', { static: true }) chk_Tochigi: CheckboxLabelComponent;
  @ViewChild('chk_Gunma', { static: true }) chk_Gunma: CheckboxLabelComponent;
  @ViewChild('chk_Chiba', { static: true }) chk_Chiba: CheckboxLabelComponent;
  @ViewChild('chk_Saitama', { static: true }) chk_Saitama: CheckboxLabelComponent;
  @ViewChild('chk_Tokyo', { static: true }) chk_Tokyo: CheckboxLabelComponent;
  @ViewChild('chk_Nagano', { static: true }) chk_Nagano: CheckboxLabelComponent;
  @ViewChild('chk_Niigata', { static: true }) chk_Niigata: CheckboxLabelComponent;
  @ViewChild('txt_DepositCapitalIncreaseCount', { static: true }) txt_DepositCapitalIncreaseCount: ElementRef;
  @ViewChild('txt_FormFlyerCode', { static: true }) txt_FormFlyerCode: ElementRef;
  @ViewChild('txt_PointNumber', { static: true }) txt_PointNumber: ElementRef;
  @ViewChild('txt_PauseGroupCode', { static: true }) txt_PauseGroupCode: ElementRef;
  @ViewChild('txt_UnitPrice', { static: true }) txt_UnitPrice: ElementRef;
  @ViewChild('cmb_PlanningManagementDetailDiv', { static: true }) cmb_PlanningManagementDetailDiv: CodeComboBoxComponent;
  @ViewChild('cmb_DeliveryLeadDiv', { static: true }) cmb_DeliveryLeadDiv: CodeComboBoxComponent;
  @ViewChild('cmb_AppropriatingClass', { static: true }) cmb_AppropriatingClass: CodeComboBoxComponent;
  @ViewChild('cmb_ConsumeTaxDiv', { static: true }) cmb_ConsumeTaxDiv: CodeComboBoxComponent;
  @ViewChild('cmb_ConsumeTaxRate', { static: true }) cmb_ConsumeTaxRate: CodeComboBoxComponent;
  @ViewChild('btn_approval', { static: true }) btn_approval: ElementRef;
  @ViewChild('cmb_PlanningManagementDiv', { static: true }) cmb_PlanningManagementDiv: CodeComboBoxComponent;
  @ViewChild('cmb_DepositCapitalIncreasePattern', { static: true }) cmb_DepositCapitalIncreasePattern: CodeComboBoxComponent;
  @ViewChild('cmb_PdDiv', { static: true }) cmb_PdDiv: CodeComboBoxComponent;
  @ViewChild('btn_Regist', { static: true }) btn_Regist: ElementRef;
  @ViewChild('txt_OrderNum', { static: true }) txt_OrderNum: ElementRef;
  @ViewChild('txt_OrderReceptionStartCatalog', { static: true }) txt_OrderReceptionStartCatalog: ElementRef;
  @ViewChild('txt_GoodsName', { static: true }) txt_GoodsName: ElementRef;
  @ViewChild('txt_StandardName', { static: true }) txt_StandardName: ElementRef;
  @ViewChild('txt_OrderReceptionEndCatalog', { static: true }) txt_OrderReceptionEndCatalog: ElementRef;
  @ViewChild('txt_GoodsNameKana', { static: true }) txt_GoodsNameKana: ElementRef;
  @ViewChild('txt_StandardNameKana', { static: true }) txt_StandardNameKana: ElementRef;

  // 生協コード
  // いばらき
  public readonly COOP_CODE_IBARAKI: string = <string>this.kymw00Model.COOP_CODE_IB;
  // とちぎ
  public readonly COOP_CODE_TOCHIGI: string = <string>this.kymw00Model.COOP_CODE_TO;
  // ぐんま
  public readonly COOP_CODE_GUNNMA: string = <string>this.kymw00Model.COOP_CODE_GU;
  // ちば
  public readonly COOP_CODE_CHIBA: string = <string>this.kymw00Model.COOP_CODE_TI;
  // さいたま
  public readonly COOP_CODE_SAITAMA: string = <string>this.kymw00Model.COOP_CODE_SA;
  // とうきょう
  public readonly COOP_CODE_TOKYO: string = <string>this.kymw00Model.COOP_CODE_TK;
  // ながの
  public readonly COOP_CODE_NAGANO: string = <string>this.kymw00Model.COOP_CODE_NA;
  // にいがた
  public readonly COOP_CODE_NIIGATA: string = <string>this.kymw00Model.COOP_CODE_NI;

  // ユーザ権限
  public isFullControl = this.getFuncPermission('KYMW7200') === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL;

  public coopMap: Map<string, string> = new Map([
    [this.COOP_CODE_IBARAKI, 'い'],
    [this.COOP_CODE_TOCHIGI, 'と'] ,
    [this.COOP_CODE_GUNNMA, 'ぐ'],
    [this.COOP_CODE_CHIBA, 'ち'],
    [this.COOP_CODE_SAITAMA, 'さ'],
    [this.COOP_CODE_TOKYO, 'とう'],
    [this.COOP_CODE_NAGANO, 'な'],
    [this.COOP_CODE_NIIGATA, 'に']
  ]);

  /**
   *Creates an instance of KYMW7201Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @param {PlessHttp} plessHttp
   * @memberof KYMW7201Component
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private getOperationGoodsService: GetOperationGoodsService,
    private updateOperationGoodsService: UpdateOperationGoodsService,
    private registOperationGoodsService: RegistOperationGoodsService,
    private countFixtationService: CountFixtationService,
    private getCodeListService: GetCodeListService,
    private route: ActivatedRoute,
    private router: Router,
    private render: Renderer2,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW7201Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW7201';
    this.kymw7201Model.kymw7201Component = this;
    
    this.route.queryParams.subscribe((params) => {
      // 遷移元が運営商品一覧画面の「詳細」ボタン押下で遷移した場合のパラメータ(運営商品ID)取得
      if ('operationGoodsId' in params) {
        this.kymw7201Model.operationGoodsId = params['operationGoodsId'];
        this.getOperationGoodsService.execute(this.kymw7201Model, this.kymw7201Model.operationGoodsId, () => {

          //取得してきた運営商品情報によって活性、非活性制御
          this.planningManagementDetailDiv_CHANGEHandler()

          //取得してきた運営商品情報の積立増資パターンによって積立増資回数の活性非活性制御
          this.cmb_depositCapitalIncreasePattern_CHANGEHandler()

          //取得してきた運営商品情報の運営企画区分によって運営企画詳細区分を設定する
          this.setPlanningManagementDetailDiv()
          this.setButtonFromDetail()

          // 受注受付終了企画回が企画確定しているとき、各項目を非活性にする
          this.setDisabledFromDetail()
        })
      } else {
        this.setButtonFromNewadd()
      }
      // 運営商品一覧画面の検索条件保持
      this.kymw7201Model.searchDeliveryDiv = params['searchDeliveryDiv'];
      this.kymw7201Model.searchOrderNum = params['searchOrderNum'];
      this.kymw7201Model.searchPlanningManagementDiv = params['searchPlanningManagementDiv'];
      this.kymw7201Model.searchGoodsName = params['searchGoodsName'];
      this.kymw7201Model.searchOrderCatalog = params['searchOrderCatalog'];
      this.kymw7201Model.searchPlanningManagementDetailDiv = params['searchPlanningManagementDetailDiv'];
      this.kymw7201Model.searchStandardName = params['searchStandardName'];
    });
  }

  /**
   * 初期表示時に積立増資回数を非活性にする処理
   */
  public ngAfterViewInit(): void {
    //積立増資回数を非活性
    this.txt_DepositCapitalIncreaseCount.nativeElement.disabled = true;
  } 

  /**
   * 詳細ボタンから遷移してきた際の権限によって登録・承認ボタンを表示・非表示にする処理
   */
  public setButtonFromDetail(): void {
    this.kymw7201Model.btnRegistDisplay = true;
    this.kymw7201Model.btnRegistEnabled = this.isFullControl;
    
    this.getCodeListService.execute(
      'ctp324',
      '',
      this.kymw7201Model,
      'arrangeDivList',
      () => {
        //セッション情報のユーザの権限セットID
        const authoritySetID = this.kymw00Model.kymw1001Model.loginUserInfo.AuthoritySetID;
        this.kymw7201Model.btnApprovalDisplay = false;
        for (let i = 0; i < this.kymw7201Model.arrangeDivList.length; i++) {
          //取得したCodeValueのうち、セッション情報のユーザの権限セットIDと一致するものがある場合、承認ボタンを活性
          if (parseInt(authoritySetID) === parseInt(this.kymw7201Model.arrangeDivList[i].CodeValue)) {
            this.kymw7201Model.btnApprovalDisplay = true;
            this.kymw7201Model.btnApprovalEnabled = this.isFullControl;
            break;
          }
        }
      },
      null
    )
  }

  /**
   * 詳細ボタンから遷移してきた際に、受注受付終了企画回が企画確定しているかによって各項目を非活性にする処理
   */
  public setDisabledFromDetail(): void {
    // 受注受付開始企画回は非活性
    this.txt_OrderReceptionStartCatalog.nativeElement.disabled = true;
    setTimeout(() => {
      this.countFixtationService.execute(this.kymw7201Model.orderReceptionEndCatalog, (data) => {
        const countFixtation = PlessViewUtilsSub.stringToNumber(data.CountFixtation);
        if (countFixtation > 0) {
          this.disableControls(
            [
              this.txt_OrderNum,
              this.txt_UnitPrice,
              this.txt_PointNumber,
              this.txt_GoodsName,
              this.txt_StandardName,
              this.txt_OrderReceptionEndCatalog,
              this.txt_FormFlyerCode,
              this.txt_PauseGroupCode,
              this.txt_GoodsNameKana,
              this.txt_StandardNameKana
            ],
            [
              this.cmb_PlanningManagementDiv,
              this.cmb_PdDiv,
              this.cmb_AppropriatingClass,
              this.cmb_PlanningManagementDetailDiv,
              this.cmb_DeliveryLeadDiv,
              this.cmb_ConsumeTaxDiv,
              this.cmb_ConsumeTaxRate
            ]
          )
          this.txt_DepositCapitalIncreaseCount.nativeElement.disabled = true;
          this.cmb_DepositCapitalIncreasePattern.disabled = true;
          this.rbtn_Weekly.disabled = true;
          this.rbtn_Daily.disabled = true;
          this.chk_AllSeikyou.disabled = true;
          this.chk_Ibaraki.disabled = true;
          this.chk_Tochigi.disabled = true;
          this.chk_Gunma.disabled = true;
          this.chk_Chiba.disabled = true;
          this.chk_Saitama.disabled = true;
          this.chk_Tokyo.disabled = true;
          this.chk_Nagano.disabled = true;
          this.chk_Niigata.disabled = true;
        }
      })
    }, 500);
  }

  /**
   * 新規追加ボタンから遷移してきた際に登録ボタンを表示にする処理
   */
  public setButtonFromNewadd(): void {
    if (PlessViewUtilsSub.isEmpty(this.kymw7201Model.operationGoodsId)) {
      this.kymw7201Model.btnRegistDisplay = true;
      this.kymw7201Model.btnRegistEnabled = this.isFullControl;
    }
  }

  /**
   * 【利用生協】全生協チェッククリック
   *
   * @param listEvent:ListEvent
   */
  public eventChkAllSeikyou_CLICKHandler(): void {
    // 取扱生協のチェックボックスにのみ
    // 全生協チェックボックスの選択状態を反映させる
    if (!this.chk_Ibaraki.disabled) {
      this.kymw7201Model.ibaraki = this.kymw7201Model.allSeikyou; // いばらき
    }
    if (!this.chk_Tochigi.disabled) {
      this.kymw7201Model.tochigi = this.kymw7201Model.allSeikyou;	// とちぎ
    }
    if (!this.chk_Gunma.disabled) {
      this.kymw7201Model.gunma = this.kymw7201Model.allSeikyou;	// ぐんま
    }
    if (!this.chk_Chiba.disabled) {
      this.kymw7201Model.chiba = this.kymw7201Model.allSeikyou;	// ちば
    }
    if (!this.chk_Saitama.disabled) {
      this.kymw7201Model.saitama = this.kymw7201Model.allSeikyou;	// さいたま
    }
    if (!this.chk_Tokyo.disabled) {
      this.kymw7201Model.tokyo = this.kymw7201Model.allSeikyou;	// とうきょう
    }
    if (!this.chk_Nagano.disabled) {
      this.kymw7201Model.nagano = this.kymw7201Model.allSeikyou;	// ながの
    }
    if (!this.chk_Niigata.disabled) {
      this.kymw7201Model.niigata = this.kymw7201Model.allSeikyou;	// にいがた
    }
  }

  /**
   * 【利用生協】生協チェッククリック
   */
  public eventChkSeikyou_CLICKHandler(e): void {
    if (e.target.checked) {
      // チェックがすべて入っている場合はALLのチェックも入れる
      this.kymw7201Model.allSeikyou = this.kymw7201Model.ibaraki &&
        this.kymw7201Model.tochigi && this.kymw7201Model.gunma &&
        this.kymw7201Model.chiba && this.kymw7201Model.saitama &&
        this.kymw7201Model.tokyo && this.kymw7201Model.nagano && this.kymw7201Model.niigata;
    } else {
      // チェックが外れた場合はALLのチェックも外す
      this.kymw7201Model.allSeikyou = false;
    }
  }

  /**
   * 生協コードを取得
   * チェックされた生協のみArrayにセットし返却
   */
  private getCoopCodeArray(): Array<any> {
    const returnArray: Array<any> = new Array<any>();
    if (this.chk_Ibaraki.selected) {
      returnArray.push(this.COOP_CODE_IBARAKI);	// いばらき
    }
    if (this.chk_Tochigi.selected) {
      returnArray.push(this.COOP_CODE_TOCHIGI);	// とちぎ
    }
    if (this.chk_Gunma.selected) {
      returnArray.push(this.COOP_CODE_GUNNMA);	// ぐんま
    }
    if (this.chk_Chiba.selected) {
      returnArray.push(this.COOP_CODE_CHIBA);	// ちば
    }
    if (this.chk_Saitama.selected) {
      returnArray.push(this.COOP_CODE_SAITAMA);	// さいたま
    }
    if (this.chk_Tokyo.selected) {
      returnArray.push(this.COOP_CODE_TOKYO);	// とうきょう
    }
    if (this.chk_Nagano.selected) {
      returnArray.push(this.COOP_CODE_NAGANO);	// ながの
    }
    if (this.chk_Niigata.selected) {
      returnArray.push(this.COOP_CODE_NIIGATA);	// にいがた
    }
    return returnArray;
  }

  /**
   * 積立増資パターンイベント処理
   */
  public cmb_depositCapitalIncreasePattern_CHANGEHandler(): void {
    // 積立増資パターンが「3：回数」の場合
    if (this.kymw7201Model.depositCapitalIncreasePattern !== '3') {
      this.txt_DepositCapitalIncreaseCount.nativeElement.disabled = true;		// 非活性
      this.kymw7201Model.depositCapitalIncreaseCount = ''
    } else {
      this.txt_DepositCapitalIncreaseCount.nativeElement.disabled = false;		// 活性
    }
  }

  /**
   * 運営企画区分チェンジイベント処理
   */
  public cmb_planningManagementDiv_CHANGEHandler(): void {

    //運営企画詳細区分の値をクリアする
    this.kymw7201Model.planningManagementDetailDiv = "";

    //入力項目を活性非活性にする
    this.changePlanningManagementDiv()
    //運営企画詳細区分を設定する
    this.setPlanningManagementDetailDiv()

    // 消費税区分設定
    this.setConsumeTaxDiv();
  }

  /**
   * 運営企画詳細区分設定する処理
   */
  public setPlanningManagementDetailDiv(): void {
    //運営企画区分の先頭の空白を押した場合
    if (PlessViewUtilsSub.isEmpty(this.kymw7201Model.planningManagementDiv)) {
      this.kymw7201Model.planningManagementDetailDiv = "";
      return;
    } else {
      // 現在のcodeDivの値を一時的にクリア
      this.kymw7201Model.setCodeDiv = "";

      // 短い遅延を設けてから再度値を設定
      setTimeout(() => {
        this.kymw7201Model.setCodeDiv = "ctp207";
      }, 500);

      //選択した運営企画区分のコード値を整数化した値
      this.kymw7201Model.setReserveNum1 = parseInt(this.kymw7201Model.planningManagementDiv, 10).toString();
    }
  }

  /**
   * 承認ボタン押下イベント処理
   */
  public eventApproval_CLICKHandler() {
    // 取扱可能生協
    this.kymw7201Model.coopCodeList = this.getCoopCodeArray();
    this.kymw7201Model.operationGoodsStatus = '2'
    // 必須項目チェック
    if (!this.requiredCommonCheckOnRegist(this.kymw7201Model)) {
      return;
    }
    if (!this.requiredCheckOnRegist(this.kymw7201Model)) {
      return;
    }
    if (!this.requiredDeliveryCheckOnRegist(this.kymw7201Model)) {
      return;
    }
    // 受注受付終了企画回が企画確定している場合エラー
    if (this.kymw7201Model.planningManagementDiv !== '91'
      && this.kymw7201Model.planningManagementDiv !== '92'
      && this.kymw7201Model.planningManagementDiv !== '93'
      && this.kymw7201Model.planningManagementDiv !== '94'
    ) {
      this.countFixtationService.execute(this.kymw7201Model.orderReceptionEndCatalog, (data) => {
        const countFixtation = PlessViewUtilsSub.stringToNumber(data.CountFixtation);
        if (countFixtation > 0) {
          this.dialogServiceSub.openAlertGetMessage('E0637', null);
          return;
        } else {
          this.updateOperationGoodsService.execute(this.kymw7201Model, () => {
            this.updateSuccess()
          })
        }
      });
    } else {
      this.updateOperationGoodsService.execute(this.kymw7201Model, () => {
        this.updateSuccess()
      })
    }
  }

  /**
   * 更新完了後処理
   *
   * @memberof KYMW7201Component
   */
  public updateSuccess(): void {
    //「{0}の更新を完了しました。」
    this.dialogServiceSub.openAlertGetMessage('I0505', ['運営商品'], (closeEvent: any) => {
      if (closeEvent === PlessAlert.Yes) {
        this.router.navigate(['/kymw/7200'], {
          queryParams: {
            // 検索条件
            searchDeliveryDiv: this.kymw7201Model.searchDeliveryDiv,
            searchOrderNum: this.kymw7201Model.searchOrderNum,
            searchPlanningManagementDiv: this.kymw7201Model.searchPlanningManagementDiv,
            searchGoodsName: this.kymw7201Model.searchGoodsName,
            searchOrderCatalog: this.kymw7201Model.searchOrderCatalog,
            searchPlanningManagementDetailDiv: this.kymw7201Model.searchPlanningManagementDetailDiv,
            searchStandardName: this.kymw7201Model.searchStandardName
          },
        });
      }
    });
  }

  /**
   * 登録ボタン押下イベント処理
   * 運営商品一覧画面の「新規追加」ボタン押下から遷移した場合、登録処理を呼び出す（運営商品IDが存在しない）
   * 運営商品一覧画面の「詳細」ボタン押下から遷移した場合、更新処理を呼び出す（運営商品IDが存在する）
   */
  public eventRegist_CLICKHandler() {
    // 取扱可能生協
    this.kymw7201Model.coopCodeList = this.getCoopCodeArray();

    if (PlessViewUtilsSub.isEmpty(this.kymw7201Model.operationGoodsId)) {
      this.kymw7201Model.operationGoodsStatus = '1';
    }

    // 項目チェック
    if (!this.requiredCommonCheckOnRegist(this.kymw7201Model)) {
      return;
    }
    if (!this.requiredCheckOnRegist(this.kymw7201Model)) {
      return;
    }
    if (!this.requiredDeliveryCheckOnRegist(this.kymw7201Model)) {
      return;
    }

    if (PlessViewUtilsSub.isEmpty(this.kymw7201Model.operationGoodsId)) {
      // 受注受付開始企画回が企画確定している場合エラー
      if (this.kymw7201Model.planningManagementDiv !== '91'
        && this.kymw7201Model.planningManagementDiv !== '92'
        && this.kymw7201Model.planningManagementDiv !== '93'
        && this.kymw7201Model.planningManagementDiv !== '94'
      ) {
        this.countFixtationService.execute(this.kymw7201Model.orderReceptionStartCatalog, (data) => {
          const countFixtation = PlessViewUtilsSub.stringToNumber(data.CountFixtation);
          if (countFixtation > 0) {
            this.dialogServiceSub.openAlertGetMessage('E0636', null);
            return;
          } else {
            this.registOperationGoodsService.execute(this.kymw7201Model, () => {
              this.registSuccess()
            })
          }
        });
      } else {
        this.registOperationGoodsService.execute(this.kymw7201Model, () => {
          this.registSuccess()
        })
      }
    } else {
      // 受注受付終了企画回が企画確定している場合エラー
      if (this.kymw7201Model.planningManagementDiv !== '91'
        && this.kymw7201Model.planningManagementDiv !== '92'
        && this.kymw7201Model.planningManagementDiv !== '93'
        && this.kymw7201Model.planningManagementDiv !== '94'
      ) {
        this.countFixtationService.execute(this.kymw7201Model.orderReceptionEndCatalog, (data) => {
          const countFixtation = PlessViewUtilsSub.stringToNumber(data.CountFixtation);
          if (countFixtation > 0) {
            this.dialogServiceSub.openAlertGetMessage('E0637', null);
            return;
          } else {
            this.updateOperationGoodsService.execute(this.kymw7201Model, () => {
              this.updateSuccess()
            })
          }
        });
      } else {
        this.updateOperationGoodsService.execute(this.kymw7201Model, () => {
          this.updateSuccess()
        })
      }
    }
  }

  /**
   * 登録完了後処理
   *
   * @memberof KYMW7201Component
   */
  public registSuccess(): void {
    //「{0}の登録を完了しました。
    this.dialogServiceSub.openAlertGetMessage('I0504', ['運営商品'], (closeEvent: any) => {
      if (closeEvent === PlessAlert.Yes) {
        this.router.navigate(['/kymw/7200'], {
          queryParams: {
            // 検索条件
            searchDeliveryDiv: this.kymw7201Model.searchDeliveryDiv,
            searchOrderNum: this.kymw7201Model.searchOrderNum,
            searchPlanningManagementDiv: this.kymw7201Model.searchPlanningManagementDiv,
            searchGoodsName: this.kymw7201Model.searchGoodsName,
            searchOrderCatalog: this.kymw7201Model.searchOrderCatalog,
            searchPlanningManagementDetailDiv: this.kymw7201Model.searchPlanningManagementDetailDiv,
            searchStandardName: this.kymw7201Model.searchStandardName
          },
        });
      }
    });
  }

  /**
   * 文字列の桁数チェック
   * @param value : 対象文字列
   * @param value : 最大桁数
   * @return true : 桁数正常
   *         false : 桁数オーバー
   */
  public isNotOverMaxLength(value: string, num: number): boolean {
    let result: boolean = <boolean>true;

    if (!PlessViewUtilsSub.isEmpty(value)) {
      if (value.length > num) {
        result = false;
      }
    }
    return result;
  }

  /**
   * 登録ボタン押下時、共通項目のチェック
   *
   * @private
   * @param {this.kymw7201Model}  サーバへのリクエストデータ
   * @returns {Boolean}
   * @memberof KYMW7201Component
   */
  private requiredCommonCheckOnRegist(kymw7201Model: KYMW7201Model): boolean {
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.operationGoodsStatus)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['運営商品ステータス']);
      return false;
    } else if (kymw7201Model.operationGoodsStatus.length !== 1) {
      this.dialogServiceSub.openAlertGetMessage('W0005', ['運営商品ステータス', '1']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.orderNum)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['注文コード']);
      return false;
    } else if (kymw7201Model.orderNum.length !== 6) {
      this.dialogServiceSub.openAlertGetMessage('W0005', ['注文コード', '6']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.planningManagementDiv)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['運営企画区分']);
      return false;
    } else if (kymw7201Model.planningManagementDiv.length !== 2) {
      this.dialogServiceSub.openAlertGetMessage('W0005', ['運営企画区分', '2']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.orderReceptionStartCatalog)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['受注受付開始企画回']);
      return false;
    } else if (kymw7201Model.orderReceptionStartCatalog.length !== 8) {
      this.dialogServiceSub.openAlertGetMessage('W0005', ['受注受付開始企画回', '8']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.orderReceptionEndCatalog)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['受注受付終了企画回']);
      return false;
    } else if (kymw7201Model.orderReceptionEndCatalog.length !== 8) {
      this.dialogServiceSub.openAlertGetMessage('W0005', ['受注受付終了企画回', '8']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.goodsName)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['商品名']);
      return false;
    } else if (!this.isNotOverMaxLength(kymw7201Model.goodsName, 15)) {
      this.dialogServiceSub.openAlertGetMessage('W0007', ['商品名', '15']);
      return false;
    }
    if (!PlessViewUtilsSub.isEmpty(kymw7201Model.goodsNameKana)) {
      if (!this.isNotOverMaxLength(kymw7201Model.goodsNameKana, 15)) {
        this.dialogServiceSub.openAlertGetMessage('W0007', ['商品名カナ', '15']);
        return false;
      }
    }
    if (!PlessViewUtilsSub.isEmpty(kymw7201Model.standardName)) {
      if (!this.isNotOverMaxLength(kymw7201Model.standardName, 10)) {
        this.dialogServiceSub.openAlertGetMessage('W0007', ['規格名', '10']);
        return false;
      }
    }
    if (!PlessViewUtilsSub.isEmpty(kymw7201Model.standardNameKana)) {
      if (!this.isNotOverMaxLength(kymw7201Model.standardNameKana, 10)) {
        this.dialogServiceSub.openAlertGetMessage('W0007', ['規格名カナ', '10']);
        return false;
      }
    }
    if (PlessViewUtilsSub.isEmptyArray(kymw7201Model.coopCodeList)) {
      this.dialogServiceSub.openAlertGetMessage('E0148', ['利用生協']);
      return false;
    } else {
      for (let i = 0; i < kymw7201Model.coopCodeList.length; i++) {
        const coopCode = kymw7201Model.coopCodeList[i];
        if (!PlessViewUtilsSub.isEmpty(coopCode)) {
          if (coopCode.length !== 3) {
            this.dialogServiceSub.openAlertGetMessage('W0005', ['利用生協', '3']);
            return false;
          }
        }
      }
    }
    return true;
  }

  /**
   * 登録ボタン押下時、運営企画区分と運営企画詳細区分の値による必須項目のチェック
   *
   * @private
   * @param {this.kymw7201Model}  サーバへのリクエストデータ
   * @returns {Boolean}
   * @memberof KYMW7201Component
   */
  private requiredCheckOnRegist(kymw7201Model: KYMW7201Model): boolean {
    //運営企画詳細区分が必須項目の場合のチェック
    if (this.kymw7201Model.planningManagementDiv !== '30' && this.kymw7201Model.planningManagementDiv !== '31') {
      if (PlessViewUtilsSub.isEmpty(kymw7201Model.planningManagementDetailDiv)) {
        this.dialogServiceSub.openAlertGetMessage('W0001', ['運営企画詳細区分']);
        return false;
      } else if (kymw7201Model.planningManagementDetailDiv.length !== 4) {
        this.dialogServiceSub.openAlertGetMessage('W0005', ['運営企画詳細区分', '4']);
        return false;
      }
    }
    switch (this.kymw7201Model.planningManagementDiv) {
      case '01':
        return this.checkPlanningManagementDetailDivFromOne(kymw7201Model)
      case '02':
        return this.checkPlanningManagementDetailDivFromTwo(kymw7201Model)
      case '03':
        return this.checkPlanningManagementDetailDivFromThree(kymw7201Model)
      case '30':
        return this.checkPlanningManagementDetailDivFromThirty(kymw7201Model)
      case '31':
        return this.checkPlanningManagementDetailDivFromThirtyOne(kymw7201Model)
      case '40':
        return this.checkPlanningManagementDetailDivFromForty(kymw7201Model)
      case '41':
        return this.checkPlanningManagementDetailDivFromFortyOne(kymw7201Model)
      case '50':
        return this.checkPlanningManagementDetailDivFromFifty(kymw7201Model)
      case '91':
        return this.checkPlanningManagementDetailDivFromNinetyOne(kymw7201Model)
      case '92':
        return this.checkPlanningManagementDetailDivFromNinetyTwo(kymw7201Model)
      case '93':
        return this.checkPlanningManagementDetailDivFromNinetyThree(kymw7201Model)
      case '94':
        return this.checkPlanningManagementDetailDivFromNinetyFour(kymw7201Model)
      default: break;
    }
  }

  /**
   * 運営企画区分が01の場合の運営企画詳細区分の入力チェック処理
   */
  private checkPlanningManagementDetailDivFromOne(kymw7201Model: KYMW7201Model): boolean {
    switch (this.kymw7201Model.planningManagementDetailDiv) {
      case '0101':
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.unitPrice)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['単価']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.unitPrice, 7)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['単価', '7']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.appropriatingClass)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['計上部門']);
          return false;
        } else if (kymw7201Model.appropriatingClass.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['計上部門', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
      case '0102':
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.depositCapitalIncreasePattern)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['積立増資パターン']);
          return false;
        } else if (kymw7201Model.depositCapitalIncreasePattern.length !== 1) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['積立増資パターン', '1']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.unitPrice)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['単価']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.unitPrice, 7)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['単価', '7']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.appropriatingClass)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['計上部門']);
          return false;
        } else if (kymw7201Model.appropriatingClass.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['計上部門', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
      case '0103':
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.appropriatingClass)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['計上部門']);
          return false;
        } else if (kymw7201Model.appropriatingClass.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['計上部門', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
    }
  }

  /**
   * 運営企画区分が02の場合の運営企画詳細区分の入力チェック処理
   */
  private checkPlanningManagementDetailDivFromTwo(kymw7201Model: KYMW7201Model): boolean {
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.unitPrice)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['単価']);
      return false;
    } else if (!this.isNotOverMaxLength(kymw7201Model.unitPrice, 7)) {
      this.dialogServiceSub.openAlertGetMessage('W0007', ['単価', '7']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.appropriatingClass)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['計上部門']);
      return false;
    } else if (kymw7201Model.appropriatingClass.length !== 2) {
      this.dialogServiceSub.openAlertGetMessage('W0005', ['計上部門', '2']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
      return false;
    } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
      this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
      return false;
    }
    return true;
  }

  /**
   * 運営企画区分が03の場合の運営企画詳細区分の入力チェック処理
   */
  private checkPlanningManagementDetailDivFromThree(kymw7201Model: KYMW7201Model): boolean {
    switch (this.kymw7201Model.planningManagementDetailDiv) {
      case '0301':
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.pointNumber)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['ポイント数']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.pointNumber, 7)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['ポイント数', '7']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
      case '0302':
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
      case '0311':
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.pointNumber)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['ポイント数']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.pointNumber, 7)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['ポイント数', '7']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
      case '0312':
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
      case '0321':
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.pointNumber)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['ポイント数']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.pointNumber, 7)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['ポイント数', '7']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
      case '0322':
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
      default:
        if (this.kymw7201Model.planningManagementDiv === '03' && (this.kymw7201Model.planningManagementDetailDiv.endsWith('0') || this.kymw7201Model.planningManagementDetailDiv.endsWith('5'))) {
          if (PlessViewUtilsSub.isEmpty(kymw7201Model.pointNumber)) {
            this.dialogServiceSub.openAlertGetMessage('W0001', ['ポイント数']);
            return false;
          } else if (!this.isNotOverMaxLength(kymw7201Model.pointNumber, 7)) {
            this.dialogServiceSub.openAlertGetMessage('W0007', ['ポイント数', '7']);
            return false;
          }
          if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
            this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
            return false;
          } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
            this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
            return false;
          }
        } else {
          if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
            this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
            return false;
          } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
            this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
            return false;
          }
        }
        return true;
    }
  }

  /**
   * 運営企画区分が30の場合の運営企画詳細区分の入力チェック処理
   */
  private checkPlanningManagementDetailDivFromThirty(kymw7201Model: KYMW7201Model): boolean {
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
      return false;
    } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
      this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
      return false;
    }
    return true;
  }

  /**
   * 運営企画区分が31の場合の運営企画詳細区分の入力チェック処理
   */
  private checkPlanningManagementDetailDivFromThirtyOne(kymw7201Model: KYMW7201Model): boolean {
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.pauseGroupCode)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['休止グループコード']);
      return false;
    } else if (kymw7201Model.pauseGroupCode.length !== 1) {
      this.dialogServiceSub.openAlertGetMessage('W0005', ['休止グループコード', '1']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
      return false;
    } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
      this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
      return false;
    }
    return true;
  }

  /**
   * 運営企画区分が40の場合の運営企画詳細区分の入力チェック処理
   */
  private checkPlanningManagementDetailDivFromForty(kymw7201Model: KYMW7201Model): boolean {
    switch (this.kymw7201Model.planningManagementDetailDiv) {
      case '4001':
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.unitPrice)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['単価']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.unitPrice, 7)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['単価', '7']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.pdDiv)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['PD区分']);
          return false;
        } else if (kymw7201Model.pdDiv.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['PD区分', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.deliveryLeadDiv)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['配達リード区分']);
          return false;
        } else if (kymw7201Model.deliveryLeadDiv.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['配達リード区分', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.appropriatingClass)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['計上部門']);
          return false;
        } else if (kymw7201Model.appropriatingClass.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['計上部門', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
      case '4002':
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.unitPrice)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['単価']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.unitPrice, 7)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['単価', '7']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.pdDiv)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['PD区分']);
          return false;
        } else if (kymw7201Model.pdDiv.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['PD区分', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.deliveryLeadDiv)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['配達リード区分']);
          return false;
        } else if (kymw7201Model.deliveryLeadDiv.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['配達リード区分', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.appropriatingClass)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['計上部門']);
          return false;
        } else if (kymw7201Model.appropriatingClass.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['計上部門', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
    }
  }

  /**
   * 運営企画区分が41の場合の運営企画詳細区分の入力チェック処理
   */
  private checkPlanningManagementDetailDivFromFortyOne(kymw7201Model: KYMW7201Model): boolean {
    switch (this.kymw7201Model.planningManagementDetailDiv) {
      case '4101':
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.unitPrice)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['単価']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.unitPrice, 7)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['単価', '7']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.pdDiv)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['PD区分']);
          return false;
        } else if (kymw7201Model.pdDiv.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['PD区分', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.deliveryLeadDiv)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['配達リード区分']);
          return false;
        } else if (kymw7201Model.deliveryLeadDiv.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['配達リード区分', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.appropriatingClass)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['計上部門']);
          return false;
        } else if (kymw7201Model.appropriatingClass.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['計上部門', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
      case '4102':
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.unitPrice)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['単価']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.unitPrice, 7)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['単価', '7']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.pdDiv)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['PD区分']);
          return false;
        } else if (kymw7201Model.pdDiv.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['PD区分', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.deliveryLeadDiv)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['配達リード区分']);
          return false;
        } else if (kymw7201Model.deliveryLeadDiv.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['配達リード区分', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.appropriatingClass)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['計上部門']);
          return false;
        } else if (kymw7201Model.appropriatingClass.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['計上部門', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
    }
  }

  /**
   * 運営企画区分が50の場合の運営企画詳細区分の入力チェック処理
   */
  private checkPlanningManagementDetailDivFromFifty(kymw7201Model: KYMW7201Model): boolean {
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.formFlyerCode)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['帳票チラシコード']);
      return false;
    } else if (kymw7201Model.formFlyerCode.length !== 5) {
      this.dialogServiceSub.openAlertGetMessage('W0005', ['帳票チラシコード', '5']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
      return false;
    } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
      this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
      return false;
    }
    return true;
  }

  /**
   * 運営企画区分が91の場合の運営企画詳細区分の入力チェック処理
   */
  private checkPlanningManagementDetailDivFromNinetyOne(kymw7201Model: KYMW7201Model): boolean {
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.unitPrice)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['単価']);
      return false;
    } else if (!this.isNotOverMaxLength(kymw7201Model.unitPrice, 7)) {
      this.dialogServiceSub.openAlertGetMessage('W0007', ['単価', '7']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.appropriatingClass)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['計上部門']);
      return false;
    } else if (kymw7201Model.appropriatingClass.length !== 2) {
      this.dialogServiceSub.openAlertGetMessage('W0005', ['計上部門', '2']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxDiv)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税区分']);
      return false;
    } else if (kymw7201Model.consumeTaxDiv.length !== 1) {
      this.dialogServiceSub.openAlertGetMessage('W0005', ['消費税区分', '1']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
      return false;
    } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
      this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
      return false;
    }
    return true;
  }

  /**
   * 運営企画区分が92の場合の運営企画詳細区分の入力チェック処理
   */
  private checkPlanningManagementDetailDivFromNinetyTwo(kymw7201Model: KYMW7201Model): boolean {
    switch (this.kymw7201Model.planningManagementDetailDiv) {
      case '9271':
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.unitPrice)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['単価']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.unitPrice, 7)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['単価', '7']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.appropriatingClass)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['計上部門']);
          return false;
        } else if (kymw7201Model.appropriatingClass.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['計上部門', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
      case '9272':
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.unitPrice)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['単価']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.unitPrice, 7)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['単価', '7']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.appropriatingClass)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['計上部門']);
          return false;
        } else if (kymw7201Model.appropriatingClass.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['計上部門', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
      default:
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.unitPrice)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['単価']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.unitPrice, 7)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['単価', '7']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.appropriatingClass)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['計上部門']);
          return false;
        } else if (kymw7201Model.appropriatingClass.length !== 2) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['計上部門', '2']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxDiv)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税区分']);
          return false;
        } else if (kymw7201Model.consumeTaxDiv.length !== 1) {
          this.dialogServiceSub.openAlertGetMessage('W0005', ['消費税区分', '1']);
          return false;
        }
        if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
          return false;
        } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
          this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
          return false;
        }
        return true;
    }
  }

  /**
   * 運営企画区分が93の場合の運営企画詳細区分の入力チェック処理
   */
  private checkPlanningManagementDetailDivFromNinetyThree(kymw7201Model: KYMW7201Model): boolean {
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.unitPrice)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['単価']);
      return false;
    } else if (!this.isNotOverMaxLength(kymw7201Model.unitPrice, 7)) {
      this.dialogServiceSub.openAlertGetMessage('W0007', ['単価', '7']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
      return false;
    } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
      this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
      return false;
    }
    return true;
  }

  /**
   * 運営企画区分が94の場合の運営企画詳細区分の入力チェック処理
   */
  private checkPlanningManagementDetailDivFromNinetyFour(kymw7201Model: KYMW7201Model): boolean {
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.unitPrice)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['単価']);
      return false;
    } else if (!this.isNotOverMaxLength(kymw7201Model.unitPrice, 7)) {
      this.dialogServiceSub.openAlertGetMessage('W0007', ['単価', '7']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(kymw7201Model.consumeTaxRate)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['消費税率']);
      return false;
    } else if (!this.isNotOverMaxLength(kymw7201Model.consumeTaxRate, 2)) {
      this.dialogServiceSub.openAlertGetMessage('W0007', ['消費税率', '2']);
      return false;
    }
    return true;
  }

  /**
   * 宅配システムチェック処理
   *
   * @private
   * @param {this.kymw7201Model}  サーバへのリクエストデータ
   * @returns {Boolean}
   * @memberof KYMW7201Component
   */
  private requiredDeliveryCheckOnRegist(kymw7201Model: KYMW7201Model): boolean {
    const orderReceptionStartCatalog = PlessViewUtilsSub.stringToNumber(kymw7201Model.orderReceptionStartCatalog);
    const orderReceptionEndCatalog = PlessViewUtilsSub.stringToNumber(kymw7201Model.orderReceptionEndCatalog);

    // 受注受付開始企画回 > 受注受付終了企画回の場合
    if (orderReceptionStartCatalog > orderReceptionEndCatalog) {
      this.dialogServiceSub.openAlertGetMessage('E0632', null);
      return false;
    }
    if (kymw7201Model.planningManagementDiv === '40' || kymw7201Model.planningManagementDiv === '41') {
      // 配達リード区分＝01のとき、PD区分=99の場合エラー
      if (kymw7201Model.deliveryLeadDiv === '01' && kymw7201Model.pdDiv === '99') {
        this.dialogServiceSub.openAlertGetMessage('E0633', ['リード１翌週配達商品', 'ＰＤ区分：１４']);
        return false;
      }
      // 配達リード区分＝02のとき、PD区分=14の場合エラー
      if (kymw7201Model.deliveryLeadDiv === '02' && kymw7201Model.pdDiv === '14') {
        this.dialogServiceSub.openAlertGetMessage('E0633', ['リード２翌々週配達商品', 'ＰＤ区分：９９']);
        return false;
      }
    } else if (kymw7201Model.planningManagementDiv === '91') {
      // 消費税区分＝1,2以外の場合エラー
      if (kymw7201Model.consumeTaxDiv !== '1' && kymw7201Model.consumeTaxDiv !== '2') {
        this.dialogServiceSub.openAlertGetMessage('E0634', null);
        return false;
      }
    } else if (kymw7201Model.planningManagementDiv === '92') {
      if (kymw7201Model.planningManagementDetailDiv !== '9271' && kymw7201Model.planningManagementDetailDiv !== '9272') {
        // 消費税区分＝1,2以外の場合エラー
        if (kymw7201Model.consumeTaxDiv !== '1' && kymw7201Model.consumeTaxDiv !== '2') {
          this.dialogServiceSub.openAlertGetMessage('E0635', null);
          return false;
        }
      }
    }
    return true;
  }

  /**
   * 入力フィールド・コンボボックスを非活性
   */
  public disableControls(inputFields: any[], comboBoxes: any[]): void {
    // 入力フィールドを非活性化 
    inputFields.forEach(field => {
      field.nativeElement.disabled = true;
    });
    // コンボボックスを非活性化 
    comboBoxes.forEach(comboBox => {
      if (comboBox === this.cmb_DepositCapitalIncreasePattern) {
        this.txt_DepositCapitalIncreaseCount.nativeElement.disabled = true;
        this.kymw7201Model.depositCapitalIncreaseCount = '';
      }
      comboBox.disabled = true;
    });
  }

  /**
   * modelの中身を初期化する
   */
  public resetModel(model: any, fields: string[]): void {
    fields.forEach(field => {
      model[field] = '';
    });
  }

  /**
   * 入力フィールド・コンボボックスを活性
   */
  public enableControls(inputFields: any[], comboBoxes: any[]): void {
    // 入力フィールドを活性化 
    inputFields.forEach(field => {
      field.nativeElement.disabled = false;
      this.render.addClass(field.nativeElement, 'text-label-required');
    });
    // コンボボックスを活性化 
    comboBoxes.forEach(field => {
      field.disabled = false;
      field.required = true;
    });
  }

  /**
   * 運営企画区分と運営企画詳細区分によって入力項目の活性非活性を変更する処理
   */
  public planningManagementDetailDiv_CHANGEHandler(): void {
    switch (this.kymw7201Model.planningManagementDiv) {
      case '01':
        switch (this.kymw7201Model.planningManagementDetailDiv) {
          case '0101':
            this.disableControls([this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'consumeTaxDiv']);
            this.enableControls([this.txt_UnitPrice], [this.cmb_AppropriatingClass]);
            this.kymw7201Model.consumeTaxRate = '0'
            break;
          case '0102':
            this.disableControls([this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            this.resetModel(this.kymw7201Model, ['formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'consumeTaxDiv']);
            this.enableControls([this.txt_UnitPrice], [this.cmb_DepositCapitalIncreasePattern, this.cmb_AppropriatingClass]);
            this.kymw7201Model.consumeTaxRate = '0'
            break;
          case '0103':
            this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'unitPrice', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'consumeTaxDiv']);
            this.enableControls([], [this.cmb_AppropriatingClass]);
            this.kymw7201Model.consumeTaxRate = '0'
            break;
        }
        break;
      case '02':
        this.disableControls([this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
        this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'consumeTaxDiv']);
        this.enableControls([this.txt_UnitPrice], [this.cmb_AppropriatingClass]);
        this.kymw7201Model.consumeTaxRate = '0'
        break;
      case '03':
        switch (this.kymw7201Model.planningManagementDetailDiv) {
          case '0301':
            this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'unitPrice', 'formFlyerCode', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
            this.enableControls([this.txt_PointNumber], []);
            this.kymw7201Model.consumeTaxRate = '0'
            break;
          case '0302':
            this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'unitPrice', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
            this.enableControls([], []);
            this.kymw7201Model.consumeTaxRate = '0'
            break;
          case '0311':
            this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'unitPrice', 'formFlyerCode', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
            this.enableControls([this.txt_PointNumber], []);
            this.kymw7201Model.consumeTaxRate = '0'
            break;
          case '0312':
            this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'unitPrice', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
            this.enableControls([], []);
            this.kymw7201Model.consumeTaxRate = '0'
            break;
          case '0321':
            this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'unitPrice', 'formFlyerCode', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
            this.enableControls([this.txt_PointNumber], []);
            this.kymw7201Model.consumeTaxRate = '0'
            break;
          case '0322':
            this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'unitPrice', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
            this.enableControls([], []);
            this.kymw7201Model.consumeTaxRate = '0'
            break;
          //03:ポイント利用の際に運営企画詳細区分が右一桁目が0または5の場合
          default:
            if (this.kymw7201Model.planningManagementDiv === '03' && (this.kymw7201Model.planningManagementDetailDiv.endsWith('0') || this.kymw7201Model.planningManagementDetailDiv.endsWith('5'))) {
              this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
              this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'unitPrice', 'formFlyerCode', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
              this.enableControls([this.txt_PointNumber], []);
              this.kymw7201Model.consumeTaxRate = '0'
            } else {
              this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
              this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'unitPrice', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
              this.enableControls([], []);
              this.kymw7201Model.consumeTaxRate = '0'
            }
        }
        break;
      case '30':
        this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
        this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'unitPrice', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
        this.enableControls([], []);
        this.kymw7201Model.consumeTaxRate = '0'
        break;
      case '31':
        this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PointNumber], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
        this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'unitPrice', 'formFlyerCode', 'pointNumber', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
        this.enableControls([this.txt_PauseGroupCode], []);
        this.kymw7201Model.consumeTaxRate = '0'
        break;
      case '40':
        switch (this.kymw7201Model.planningManagementDetailDiv) {
          case '4001':
            this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'appropriatingClass', 'consumeTaxDiv']);
            this.enableControls([], [this.cmb_PdDiv, this.cmb_DeliveryLeadDiv]);
            this.kymw7201Model.consumeTaxRate = '0'
            this.kymw7201Model.unitPrice = '0' //価格を"0に"設定
            this.kymw7201Model.appropriatingClass = '70' //計上部門を 70(会員独自企画)に設定
            break;
          case '4002':
            this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'appropriatingClass', 'consumeTaxDiv']);
            this.enableControls([], [this.cmb_PdDiv, this.cmb_DeliveryLeadDiv]);
            this.kymw7201Model.consumeTaxRate = '0'
            this.kymw7201Model.unitPrice = '0' //価格を"0に"設定
            this.kymw7201Model.appropriatingClass = '70' //計上部門を 70(会員独自企画)に設定
            break;
        }
        break;
      case '41':
        switch (this.kymw7201Model.planningManagementDetailDiv) {
          case '4101':
            this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'appropriatingClass', 'consumeTaxDiv']);
            this.enableControls([], [this.cmb_PdDiv, this.cmb_DeliveryLeadDiv]);
            this.kymw7201Model.consumeTaxRate = '0'
            this.kymw7201Model.unitPrice = '0' //価格を"0に"設定
            this.kymw7201Model.appropriatingClass = '70' //計上部門を 70(会員独自企画)に設定
            break;
          case '4102':
            this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'appropriatingClass', 'consumeTaxDiv']);
            this.enableControls([], [this.cmb_PdDiv, this.cmb_DeliveryLeadDiv]);
            this.kymw7201Model.consumeTaxRate = '0'
            this.kymw7201Model.unitPrice = '0' //価格を"0に"設定
            this.kymw7201Model.appropriatingClass = '70' //計上部門を 70(会員独自企画)に設定
            break;
        }
        break;
      case '50':
        this.disableControls([this.txt_UnitPrice, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
        this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'unitPrice', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
        this.enableControls([this.txt_FormFlyerCode], []);
        this.kymw7201Model.consumeTaxRate = '0'
        break;
      case '91':
        this.disableControls([this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv]);
        this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv']);
        this.enableControls([this.txt_UnitPrice], [this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
        break;
      case '92':
        switch (this.kymw7201Model.planningManagementDetailDiv) {
          case '9271':
            this.disableControls([this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'consumeTaxDiv']);
            this.enableControls([this.txt_UnitPrice], [this.cmb_AppropriatingClass]);
            this.kymw7201Model.consumeTaxRate = '0'
            break;
          case '9272':
            this.disableControls([this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'consumeTaxDiv']);
            this.enableControls([this.txt_UnitPrice], [this.cmb_AppropriatingClass]);
            this.kymw7201Model.consumeTaxRate = '0'
            break;
          default:
            this.disableControls([this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv]);
            this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv']);
            this.enableControls([this.txt_UnitPrice], [this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
            break;
        }
        break;
      case '93':
        this.disableControls([this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
        this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
        this.enableControls([this.txt_UnitPrice], []);
        this.kymw7201Model.consumeTaxRate = '0'
        break;
      case '94':
        this.disableControls([this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
        this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
        this.enableControls([this.txt_UnitPrice], []);
        this.kymw7201Model.consumeTaxRate = '0'
        break;
      default: break;
    }

    // 消費税区分設定
    this.setConsumeTaxDiv();
  }

  /**
   * 運営企画区分と運営企画詳細区分によって消費税区分を設定する処理
   */
  public setConsumeTaxDiv(): void {
    switch (this.kymw7201Model.planningManagementDiv) {
      case '03': // ポイント利用
        switch (this.kymw7201Model.planningManagementDetailDiv) {
          case '0300': // ポイント値引（一部ポイント）
          case '0309': // ポイント値引（全ポイント）
            this.kymw7201Model.consumeTaxDiv = '3'; // 非課税
            break;
          case '':
          case undefined: // 未選択
            this.kymw7201Model.consumeTaxDiv = '';
            break;
          default: // 上記以外
            this.kymw7201Model.consumeTaxDiv = '9'; // 課税対象外
            break;
        }
        break;
      case '40': // 資料請求
      case '41': // 募集
        this.kymw7201Model.consumeTaxDiv = '1'; // 外税
        break;
      case '91': // 供給
        // 画面で入力した消費税区分
        break;
      case '92': // 手数料
        switch (this.kymw7201Model.planningManagementDetailDiv) {
          case '9271': // コンビニ振込対応手数料
          case '9272': // コンビニ振込対応手数料　税１０％
            this.kymw7201Model.consumeTaxDiv = '9'; // 課税対象外
            break;
          case '':
          case undefined: // 未選択
            this.kymw7201Model.consumeTaxDiv = '';
            break;
          default: // 上記以外
            // 画面で入力した消費税区分
            break;
        }
        break;
      case '':
      case undefined: // 未選択
        this.kymw7201Model.consumeTaxDiv = '';
        break;
      default: // 上記以外
        this.kymw7201Model.consumeTaxDiv = '9' // 課税対象外
        break;
    }
  }

  /**
   * 運営企画区分の値のみで入力項目を活性非活性にする場合の処理
   */
  public changePlanningManagementDiv(): void {
    switch (this.kymw7201Model.planningManagementDiv) {
      case '02':
        this.disableControls([this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
        this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'consumeTaxDiv']);
        this.enableControls([this.txt_UnitPrice], [this.cmb_PlanningManagementDetailDiv, this.cmb_AppropriatingClass]);
        this.kymw7201Model.consumeTaxRate = '0'
        break;
      case '30':
        this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
        this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'unitPrice', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
        this.enableControls([], []);
        this.cmb_PlanningManagementDetailDiv.required = false; //30：忘れず注文一括休みの場合、運営企画詳細区分は必須入力ではないため入力項目の背景色を白に変更
        this.kymw7201Model.consumeTaxRate = '0'
        break;
      case '31':
        this.disableControls([this.txt_UnitPrice, this.txt_FormFlyerCode, this.txt_PointNumber], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
        this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'unitPrice', 'formFlyerCode', 'pointNumber', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
        this.enableControls([this.txt_PauseGroupCode], []);
        this.cmb_PlanningManagementDetailDiv.required = false; //31：忘れず注文グループ休みの場合、運営企画詳細区分は必須入力ではないため入力項目の背景色を白に変更
        this.kymw7201Model.consumeTaxRate = '0'
        break;
      case '50':
        this.disableControls([this.txt_UnitPrice, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
        this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'unitPrice', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
        this.enableControls([this.txt_FormFlyerCode], [this.cmb_PlanningManagementDetailDiv]);
        this.kymw7201Model.consumeTaxRate = '0'
        break;
      case '91':
        this.disableControls([this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv]);
        this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv']);
        this.enableControls([this.txt_UnitPrice], [this.cmb_PlanningManagementDetailDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
        break;
      case '93':
        this.disableControls([this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
        this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
        this.enableControls([this.txt_UnitPrice], [this.cmb_PlanningManagementDetailDiv]);
        this.kymw7201Model.consumeTaxRate = '0'
        break;
      case '94':
        this.disableControls([this.txt_FormFlyerCode, this.txt_PointNumber, this.txt_PauseGroupCode], [this.cmb_DepositCapitalIncreasePattern, this.cmb_PdDiv, this.cmb_DeliveryLeadDiv, this.cmb_AppropriatingClass, this.cmb_ConsumeTaxDiv, this.cmb_ConsumeTaxRate]);
        this.resetModel(this.kymw7201Model, ['depositCapitalIncreasePattern', 'formFlyerCode', 'pointNumber', 'pauseGroupCode', 'pdDiv', 'deliveryLeadDiv', 'appropriatingClass', 'consumeTaxDiv']);
        this.enableControls([this.txt_UnitPrice], [this.cmb_PlanningManagementDetailDiv]);
        this.kymw7201Model.consumeTaxRate = '0'
        break;
      default:
        //上記以外の場合は全入力項目を活性化
        this.enableControls([], [this.cmb_PlanningManagementDetailDiv]);
        break;
    }
  }

  /**
   * kymw7200:運営商品一覧に戻るボタン押下時の処理
   */
  public eventBack_CLICKHandler(): void {
    this.router.navigate(['/kymw/7200'], {
      queryParams: {
        // 検索条件
        searchDeliveryDiv: this.kymw7201Model.searchDeliveryDiv,
        searchOrderNum: this.kymw7201Model.searchOrderNum,
        searchPlanningManagementDiv: this.kymw7201Model.searchPlanningManagementDiv,
        searchGoodsName: this.kymw7201Model.searchGoodsName,
        searchOrderCatalog: this.kymw7201Model.searchOrderCatalog,
        searchPlanningManagementDetailDiv: this.kymw7201Model.searchPlanningManagementDetailDiv,
        searchStandardName: this.kymw7201Model.searchStandardName
      },
    });
  }

  /**
   * 商品名(ｶﾅ)の入力から半角カンマを削除
   */
  public eventGoodsNameKana_deleteCommaHandler(): void {
    this.kymw7201Model.goodsNameKana = this.kymw7201Model.goodsNameKana.replace(/,/g, '');
    // 画面に反映
    this.txt_GoodsNameKana.nativeElement.value = this.kymw7201Model.goodsNameKana; 
  }

  /**
   * 規格名(ｶﾅ)の入力から半角カンマを削除
   */
  public eventStandardNameKana_deleteCommaHandler(): void {
    this.kymw7201Model.standardNameKana = this.kymw7201Model.standardNameKana.replace(/,/g, '');
    // 画面に反映
    this.txt_StandardNameKana.nativeElement.value = this.kymw7201Model.standardNameKana; 
  }
}
